export default {
  dashboard: (state) => {
    return state.dashboard;
  },
  profile: (state) => {
    return state.profile;
  },
  polls: (state) => {
    return state.polls;
  },
  pollById: (state) => {
    return state.pollById;
  },

  config: (state) => {
    return state.config;
  },
  configForPanel: (state) => {
    return state.configForPanel;
  },
  files: (state) => {
    return state.files;
  },
  file: (state) => {
    return state.file;
  },
  fileGrouping: (state) => {
    const list = [];
    state.fileGrouping.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },
  filesTime: (state) => {
    return state.filesTime;
  },

  banners: (state) => {
    return state.banners;
  },
  bannerTypes: () => {
    return [
      {
        value: 1,
        text: "مشتریان ما",
      },
      {
        value: 2,
        text: "افتخارات ما",
      },
    ];
  },

  sliders: (state) => {
    return state.sliders;
  },
  socialMedia: (state) => {
    return state.socialMedia;
  },
  socialMediaOptions: (state) => {
    const socialMediaOptions = [];
    state.socialMedia.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      socialMediaOptions.push(pushItem);
    }
    return socialMediaOptions;
  },

  socialNetworks: (state) => {
    return state.socialNetworks;
  },
  socialNetworkOptions: (state) => {
    const socialNetworkOptions = [];
    state.socialNetworks.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      socialNetworkOptions.push(pushItem);
    }
    return socialNetworkOptions;
  },

  menus: (state) => {
    return state.menus;
  },
  menu: (state) => {
    return state.menu;
  },
  pages: (state) => {
    return state.pages;
  },
  page: (state) => {
    return state.page;
  },
  posters: (state) => {
    return state.posters;
  },
  positions: (state) => {
    const list = [];
    state.positions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },
  widgets: (state) => {
    return state.widgets;
  },
  widget: (state) => {
    return state.widget;
  },
  widgetItems: (state) => {
    return state.widgetItems;
  },

  widgetOptions: (state) => {
    const widgetOptions = [];
    let pushItem = {};
    state.widgetItems.forEach(func);
    function func(item) {
      if (item.imageAddress) {
        pushItem = {
          value: item.id,
          id: item.id,
          text: item.title,
          title: item.title,
          imageAddress: item.imageAddress,
        };
      } else if (item.defaultImageAddress) {
        pushItem = {
          value: item.id,
          id: item.id,
          text: item.title,
          title: item.title,
          imageAddress: item.defaultImageAddress,
        };
      }
      widgetOptions.push(pushItem);
    }
    return widgetOptions;
  },

  categories: (state) => {
    const list = [];
    state.categories.forEach(func);
    function func(item) {
      if (item.id < 3) {
        const pushItem = {
          value: item.id,
          text: item.title,
        };
        list.push(pushItem);
      }
    }
    return list;
  },
  categoryChilds: (state) => {
    return state.categoryChilds;
  },

  waitingTickets: (state) => {
    return state.waitingTickets;
  },
  answeredTickets: (state) => {
    return state.answeredTickets;
  },
  closedTickets: (state) => {
    return state.closedTickets;
  },
  ticket: (state) => {
    return state.ticket;
  },
  ticketCategories: (state) => {
    return state.ticketCategories;
  },

  units: (state) => {
    return state.units;
  },

  unitOptions: (state) => {
    const unitOptions = [];
    state.units.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      unitOptions.push(pushItem);
    }
    return unitOptions;
  },

  posts: (state) => {
    return state.posts;
  },
  post: (state) => {
    return state.post;
  },
  deletePosts: (state) => {
    return state.deletePosts;
  },

  images: (state) => {
    return state.images;
  },
  image: (state) => {
    return state.image;
  },
  deletedImages: (state) => {
    return state.deletedImages;
  },

  videos: (state) => {
    return state.videos;
  },
  video: (state) => {
    return state.video;
  },
  deletedVideos: (state) => {
    return state.deletedVideos;
  },

  sounds: (state) => {
    return state.sounds;
  },
  sound: (state) => {
    return state.sound;
  },
  deletedSounds: (state) => {
    return state.deletedSounds;
  },

  approvedComments: (state) => {
    return state.approvedComments;
  },
  unapprovedComments: (state) => {
    return state.unapprovedComments;
  },
  comment: (state) => {
    return state.comment;
  },
  ///////////////////////////////////////////////////
  colors: (state) => {
    return state.colors;
  },
  colorOptions: (state) => {
    const colorOptions = [];
    state.colors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        hexCode: item.hexCode,
      };
      colorOptions.push(pushItem);
    }
    return colorOptions;
  },

  designTypes: (state) => {
    return state.designTypes;
  },
  designTypeOptions: (state) => {
    const designTypeOptions = [];
    state.designTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      designTypeOptions.push(pushItem);
    }
    return designTypeOptions;
  },

  commodities: (state) => {
    return state.commodities;
  },
  commodityOptions: (state) => {
    const commodityOptions = [];
    state.commodities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code + " | " + item.title,
        title: item.title,
        isRawMaterial: item.isRawMaterial,
        isProduct: item.isProduct,
      };
      commodityOptions.push(pushItem);
    }
    return commodityOptions;
  },
  packings: (state) => {
    return state.packings;
  },
  packingOptions: (state) => {
    const packingOptions = [];
    state.packings.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      packingOptions.push(pushItem);
    }
    return packingOptions;
  },

  packingInfo: (state) => {
    return state.packingInfo;
  },

  machines: (state) => {
    return state.machines;
  },

  templates: (state) => {
    return state.templates;
  },

  productPrice: (state) => {
    return state.productPrice;
  },

  benefitsAndDeduction: (state) => {
    return state.benefitsAndDeduction;
  },

  typeItem: () => {
    return [
      {
        value: 1,
        text: "مزایا",
      },
      {
        value: 2,
        text: "کسورات",
      },
    ];
  },

  boms: (state) => {
    return state.boms;
  },
  bom: (state) => {
    return state.bom;
  },

  bomOptions: (state) => {
    const bomOptions = [];
    state.bom.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.commodityTitle,
      };
      bomOptions.push(pushItem);
    }
    return bomOptions;
  },

  workCalender: (state) => {
    return state.workCalender;
  },

  fiscalYear: (state) => {
    return state.fiscalYear;
  },
  fiscalYearOptions: (state) => {
    const fiscalYearOptions = [];
    state.fiscalYear.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.year,
      };
      fiscalYearOptions.push(pushItem);
    }
    return fiscalYearOptions;
  },

  annualBase: (state) => {
    return state.annualBase;
  },

  unitPosition: (state) => {
    return state.unitPosition;
  },

  Jobs: (state) => {
    return state.Jobs;
  },

  banks: (state) => {
    return state.banks;
  },

  accounts: (state) => {
    return state.accounts;
  },
  accountOptions: (state) => {
    const accountOptions = [];
    state.accounts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      accountOptions.push(pushItem);
    }
    return accountOptions;
  },

  accountInfo: (state) => {
    return state.accountInfo;
  },
  accountInfoOptions: (state) => {
    const accountInfoOptions = [];
    state.accountInfo.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      accountInfoOptions.push(pushItem);
    }
    return accountInfoOptions;
  },

  treeAccountInfo: (state) => {
    return state.treeAccountInfo;
  },

  taxs: (state) => {
    return state.taxs;
  },

  inputOutputs: (state) => {
    return state.inputOutputs;
  },

  companyInfo: (state) => {
    return state.companyInfo;
  },

  measurementUnits: (state) => {
    return state.measurementUnits;
  },
  measurementUnitOptions: (state) => {
    const unitOptions = [];
    state.measurementUnits.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      unitOptions.push(pushItem);
    }
    return unitOptions;
  },
  cars: (state) => {
    return state.cars;
  },
  car: (state) => {
    return state.car;
  },

  carOptions: (state) => {
    const carOptions = [];
    state.cars.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      carOptions.push(pushItem);
    }
    return carOptions;
  },

  saleTypes: (state) => {
    return state.saleTypes;
  },
  saleType: (state) => {
    return state.saleType;
  },
  saleTypeOptions: (state) => {
    const saleTypeOptions = [];
    state.saleTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      saleTypeOptions.push(pushItem);
    }
    return saleTypeOptions;
  },
  transactions: (state) => {
    return state.transactions;
  },
  factors: (state) => {
    return state.factors;
  },
  finishFactors: (state) => {
    return state.finishFactors;
  },

  ordersSettings: (state) => {
    return state.ordersSettings;
  },
};
